import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { ORGANIZATIONS } from '../store/actionTypes';
import { Organizations } from './models/organizations';

export const organizations = createApi({
  reducerPath: ORGANIZATIONS,
  baseQuery,
  tagTypes: ['Organizations'],
  endpoints: builder => ({
    organization: builder.query<Organizations[], { search: string }>({
      query: variables => ({
        document: gql`
          query Organization($search: String!) {
            organization(search: $search) {
              id
              name
              address {
                digital
                streetNumber
                unitNumber
                streetName
                township
                stateOrProvince
                postalCode
                country
                note
              }
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.organization,
    }),
  }),
});

export const { useOrganizationQuery, useLazyOrganizationQuery } = organizations;
